import React from "react";
import { useI18n } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";

export const Concept = () => {
  const { t } = useI18n();
  return (
    <section id="concept" className="py-28 md:py-40 border-b border-vm-border" data-testid="concept-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10">
        <Reveal className="md:col-span-2">
          <p className="vm-label">{t("concept.label")}</p>
        </Reveal>
        <div className="md:col-span-10">
          <Reveal>
            <h2 className="font-serif font-light leading-[1] text-4xl md:text-6xl lg:text-7xl">
              <span className="block">{t("concept.line1")}</span>
              <span className="block text-vm-text2">{t("concept.line2")}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-10 max-w-2xl text-base md:text-lg text-vm-text2 font-light leading-relaxed">
              {t("concept.body")}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
